import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navbar, NavbarContent, NavbarItem } from '@heroui/react';
import { Link } from 'react-router-dom';
import {
  faDiscord,
  faInstagram,
  faReddit,
  faTiktok,
  faTwitch,
  faXTwitter
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer>
      <Navbar
        height="1.5rem"
        isBordered
        className="py-0 bg-slate-100 dark:bg-gray-950 border-t-1 border-b-0"
        classNames={{
          wrapper: 'px-2'
        }}
        maxWidth="full">
        <NavbarContent justify="start" className="gap-2">
          <NavbarItem className="border-r-1 pr-2 border-divider">
            <Link
              to="https://thedmsark.com/privacy-policy"
              target="_blank"
              className="flex items-center">
              <span className="text-xs text-gray-600 dark:text-gray-500">Privacy Policy</span>
            </Link>
          </NavbarItem>
        </NavbarContent>
        <NavbarContent justify="end" className="gap-2">
          <NavbarItem className="border-r-1 border-divider">
            <Link
              to="https://instagram.com/thedmsark"
              target="_blank"
              className="flex items-center text-xs text-gray-600 dark:text-gray-500 hover:dark:text-gray-300 hover:text-gray-800">
              <FontAwesomeIcon icon={faInstagram} className="mr-2" />
            </Link>
          </NavbarItem>
          <NavbarItem className="border-r-1 border-divider">
            <Link
              to="https://tiktok.com/@thedmsark"
              target="_blank"
              className="flex items-center text-xs text-gray-600 dark:text-gray-500 hover:dark:text-gray-300 hover:text-gray-800">
              <FontAwesomeIcon icon={faTiktok} className="mr-2" />
            </Link>
          </NavbarItem>
          <NavbarItem className="border-r-1 border-divider">
            <Link
              to="https://x.com/thedmsark"
              target="_blank"
              className="flex items-center text-xs text-gray-600 dark:text-gray-500 hover:dark:text-gray-300 hover:text-gray-800">
              <FontAwesomeIcon icon={faXTwitter} className="mr-2" />
            </Link>
          </NavbarItem>
          <NavbarItem className="border-r-1 border-divider">
            <Link
              to="https://www.reddit.com/r/thedmsark"
              target="_blank"
              className="flex items-center text-xs text-gray-600 dark:text-gray-500 hover:dark:text-gray-300 hover:text-gray-800">
              <FontAwesomeIcon icon={faReddit} className="mr-2" />
            </Link>
          </NavbarItem>
          <NavbarItem className="border-r-1 border-divider">
            <Link
              to="https://www.twitch.tv/thedmsark"
              target="_blank"
              className="flex items-center text-xs text-gray-600 dark:text-gray-500 hover:dark:text-gray-300 hover:text-gray-800">
              <FontAwesomeIcon icon={faTwitch} className="mr-2" />
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link to="https://discord.gg/9NDYNcd7eF" target="_blank" className="flex items-center">
              <span className="text-xs text-gray-600 dark:text-gray-200">
                <FontAwesomeIcon icon={faDiscord} className="mr-2" />
                <span className="hidden sm:inline">Join our Discord!</span>
              </span>
            </Link>
          </NavbarItem>
        </NavbarContent>
      </Navbar>
    </footer>
  );
};

export default Footer;
